'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAdjective = getAdjective;
exports.getItemRevenue = getItemRevenue;
exports.parsePartners = parsePartners;
exports.calculatePrices = calculatePrices;

var _config = require('../config');

var _Offer = require('../models/Offer');

var _constants = require('../constants');

function getAdjective(rating) {
  if (rating >= 9.5) return 'Exceptional';
  if (rating >= 8.5) return 'Fantastic';
  if (rating >= 8) return 'Very good';
  if (rating >= 7) return 'Good';
  return null;
}

function getItemRevenue(revenue) {
  if (!revenue) return 0;
  var country = global.hr ? global.hr.intl.COUNTRY_CODE : 'es';
  var platformId = global.isPhone ? 1 : global.isTablet ? 2 : 0; // eslint-disable-line
  return revenue[country] ? revenue[country][platformId] || 0 : 0;
}

function sortImages(images, partner) {
  if (!images[0] || !images[0].partners || !images[1] || !images[1].partners) return images;
  var img = images.find(function (image) {
    return image.partners && image.partners.indexOf(partner) >= 0;
  });
  if (!img) return images;
  images.splice(images.indexOf(img), 1);
  images.splice(0, 0, img);
  return images;
}

function airbnbRequirements(estb) {
  var isAirbnbWinner = estb.partners[0].partner_id === _constants.PARTNER_IDS.AIRBNB;
  var haveAirbnbPrice = estb.partners.some(function (p) {
    return p.partner_id === _constants.PARTNER_IDS.AIRBNB && p.price_per_day;
  });
  if (!isAirbnbWinner || estb.partners.length > 1 && !haveAirbnbPrice) {
    estb.partners = estb.partners.filter(function (partner) {
      return partner.partner_id !== _constants.PARTNER_IDS.AIRBNB;
    });
  }
  return estb;
}

function parsePartners(item, createMatching) {
  return item.matching_publications ? item.matching_publications.map(function (match) {
    return createMatching(match);
  }) : [];
}

function calculatePrices(estb) {
  var allPartners = (0, _config.getConfig)('PARTNERS');
  var partners = (0, _Offer.findPrices)(estb.partners, allPartners);

  if (!partners || !partners.length) return estb;

  estb.partners = (0, _Offer.sortPublications)(estb.partners, allPartners).filter(function (p) {
    return Object.keys(allPartners).includes(String(p.partner_id));
  });
  var haveAirbnb = estb.partners.some(function (partner) {
    return partner.partner_id === _constants.PARTNER_IDS.AIRBNB;
  });

  estb = haveAirbnb ? airbnbRequirements(estb) : estb; // eslint-disable-line
  estb.cheapestPartner = partners[0].partner_id;
  estb.qualityScore = partners[0].quality_score;
  estb.availability = calculateAvailability(estb);
  estb.cancellationPolicy = isCancellationPolicyAvailable(partners);
  estb.images = sortImages(estb.images, allPartners[partners[0].partner_id].name);
  estb.numberOfComments = estb.partners.reduce(function (res, cur) {
    return res += cur.num_comments || 0;
  }, 0); // eslint-disable-line
  estb.minDayPrice = partners[0].price_per_day || null;
  estb.minTotalPrice = partners[0].price_total || null;
  estb.maxDayPrice = partners[partners.length - 1].price_per_day || null;
  estb.maxTotalPrice = partners[partners.length - 1].price_total || null;
  estb.discount = calculateDiscount(estb);

  if (_constants.HOTEL_CATEGORIES.includes(estb.category)) {
    estb.maxGuests = estb.partners[0].rooms ? estb.partners[0].rooms.reduce(function (res, cur) {
      return res += cur;
    }, 0) : 1; // eslint-disable-line
    estb.rooms = estb.partners[0].rooms ? estb.partners[0].rooms.length : 1;
    estb.features = estb.partners[0].features ? estb.partners[0].features : [];
  }
  return estb;
}

function calculateAvailability(estb) {
  var winner = estb.partners.find(function (p) {
    return p.partner_id === estb.cheapestPartner;
  });
  return estb.cheapestPartner && winner && winner.instantly_booking ? _constants.AVAILABILITY.INSTANTLY : _constants.AVAILABILITY.UNDER_DEMAND;
}

function isCancellationPolicyAvailable(partners) {
  if (!partners[0].cancellation_policy || JSON.stringify(partners[0].cancellation_policy) === '{}') return false;
  return partners[0].cancellation_policy['100'] !== undefined ? _constants.CANCELLATION_POLICY.FULL : _constants.CANCELLATION_POLICY.PARTIAL;
}

function calculateDiscount(estb) {
  if (estb.partners.length > 1) {
    var priceSaved = estb.minDayPrice ? estb.maxDayPrice - estb.minDayPrice : 0;
    var discount = priceSaved > 0 ? Math.round(priceSaved / estb.maxDayPrice * 100) : 0;
    return discount > _constants.MIN_DISCOUNT_VALUE && discount < _constants.MAX_DISCOUNT_VALUE ? discount : null;
  }
  return null;
}